<template>
    <div class="rucontent">
        <div class="ruls">
             <div class="rich-view" v-html="htmlStr"></div>
        </div>
    </div>
</template>

<script>
    import {getRules} from "@/api/index.js"
    export default { 
        name: 'Rules',
        data() {
            return {
                htmlStr:""
            }
        },
        watch: {
          $route(to, from) {
            if (to.path === from.path) {
              let type = this.$route.query.type
              this.getRules(type) // 重新请求接口、重置表单等
            }
          }
        },
        created() {
            let type = this.$route.query.type
            this.getRules(type)
            // getRules(){
                
            // }
        },
        methods: {
            getRules(e){
                let that = this 
                getRules(e).then((res) => {
                    console.log(res)
                    if(res.code == 1){
                        that.htmlStr = res.data.content
                    }
                })
            },
            handleSelect(e) {
                console.log(e)
                if (e == 1) {
                    if (this.$route.path === '/shopIndex') return
                    // 路由跳转
                    this.$router.push('/shopIndex')
                }
            }
        }
    }
</script>

<style scoped>
   /* 穿透，修改富文本内部img */
   .rich-view /deep/ img {
     max-width: 100% !important;
     width: 100% !important;
     height: auto !important;
     display: block;
   }
    .rucontent{
        box-sizing: border-box;
        padding: 20px 0;
        text-align: left;
    }
    .rich-view{
        background: #fff;
        width: 1600px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 20px;
    }
</style>